import React from 'react';
import Text from '../Asset/Text/Text';
import Image from '../Asset/Image/Image';
import Download from '../Asset/Download/Download';
import Pdf from '../Asset/Pdf/Pdf';
import { useSelector, shallowEqual } from 'react-redux';

const getAssetFilePath = (id, dataUrl, assets) => {
  let file = 'no asset found';
  let asset = assets.find(a => a.id === id);
  // if we found an asset
  if (asset) {
    file = asset ? `${dataUrl}assets/${asset.file}` : file;
  }
  return file;
};

// the hook way of getting an assets by ID
// TODO: refactor other components to use this
export const useAsset = id => {
  let { dataUrl, assetManifest } = useSelector(
    state => state.BlockState,
    shallowEqual
  );
  let asset = assetManifest.assets.find(a => a.id === id);
  // TODO: migrate this logic to Markdown component where assets.ymls are collected
  if (asset) {
    asset = JSON.parse(JSON.stringify(asset));
    if (asset && asset.file) {
      asset.file = dataUrl + 'assets/' + asset.file;
    }
  }
  return asset ? asset : 'no asset found with ID: ' + id;
};

const getAssetTextContent = (id, assets) => {
  let txt = 'no asset found';
  let asset = assets.find(a => a.id === id);
  txt = asset && asset.content ? asset.content : txt;
  return txt;
};

const NoAsset = () => {
  return (
    <div className="text-warning">Asset component called without an ID</div>
  );
};

const Asset = ({ id, style, className, md, zoom }) => {
  let { dataUrl, assetManifest } = useSelector(
    state => state.BlockState,
    shallowEqual
  );
  let asset = assetManifest.assets.find(a => a.id === id);
  let assetDisplay;

  if (!asset) return <NoAsset />;

  if (asset.type === 'text')
    assetDisplay = (
      <Text
        id={id}
        md={md === false ? false : true}
        content={asset.content}
        className={className}
        style={{ ...style }}
      />
    );

  if (asset.type === 'image')
    assetDisplay = (
      <Image
        zoom={zoom}
        style={{ ...style }}
        id={id}
        src={`${dataUrl}assets/${asset.file}`}
        alt={asset.description}
        className={className}
      />
    );

  if (
    asset.type === 'file' &&
    (asset.subtype === 'pka' || asset.subtype === 'pkt')
  )
    assetDisplay = <Download id={id} />;

  if (
    asset.type === 'file' &&
    (asset.subtype === 'pdf' || asset.subtype === 'lab')
  )
    assetDisplay = <Pdf id={id} />;

  return assetDisplay;
};

export { getAssetFilePath, getAssetTextContent };
export default React.memo(Asset);
